/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Node } from '@msdyn365-commerce-modules/utilities';

import { IDobbiesContentBlockCarouselViewProps } from './dobbies-content-block-carousel';

export default (props: IDobbiesContentBlockCarouselViewProps) => {
    return (
        <div className={`row ms-product-collection ${props.config.className}`}>
            <h2 className='content-block-carousel-heading'>{props.config.heading}</h2>
            <Node {...props.SingleSlideCarouselComponentProps}>
                {props.slots.contentBlocks.map((contentBlock, i) => {
                    return (
                        <Node className='content-block-carousel-item' key={i}>
                            {contentBlock}
                        </Node>
                    );
                })}
            </Node>
        </div>
    );
};
